import { ATSConnectHiringRequestTestIds } from 'data-testids/ATS';
import { CandidateFeedbackModal } from '../../CandidateFeedback/FeedbackDetail/CandidateFeedbackModal';
import { CandidateRow } from '../../styles/hiringRequestStyles';
import { CandidateRowActions } from '../Actions/CandidateRowActions';
import { ConnectCandidateRowProps } from '../../types';
import { RowCandidateAndRequestorInfo } from '../../CandidateFeedback/FeedbackDetail/components/RowCandidateAndRequestorInfo';
import { RowJobInfo } from './components/RowJobInfo';
import { HiringRequestStatusDisplay } from './components/HiringRequestStatusDisplay';
import { Box, styled } from '@mui/material';
import { CandidateModal } from 'features/Principal/PrincipalCandidatesList/CandidateModal';
import { CandidateFeedbackModalTypes } from '../../enums';

export const ConnectCandidateRow: React.FC<ConnectCandidateRowProps> = ({
  currentModalOpen,
  currentRow,
  onCloseModal,
  onOpenModal,
  isModalOpen,
}) => {
  const {
    application_id: applicationId,
    candidate,
    created,
    id: hiringRequestId,
    notes_count: notesCount,
    requester: requestor,
    requirements,
    role,
    status,
    has_scorecards,
    has_references,
    candidate_info_submitted,
  } = currentRow;

  const actions = {
    scorecard: has_scorecards,
    reference: has_references,
    application: Boolean(candidate_info_submitted),
  };

  const hasCompletedAllRequiredActions =
    (!requirements.is_scorecard_required || actions.scorecard) &&
    (!requirements.is_reference_required || actions.reference) &&
    actions.application;

  const handleOpenCandidateModal = () => {
    onOpenModal({
      candidateId: candidate.id,
      modalType: CandidateFeedbackModalTypes.CANDIDATE,
      roleId: role.id,
    });
  };

  return (
    <>
      <CandidateRow data-testid={ATSConnectHiringRequestTestIds.CANDIDATE_ROW}>
        <Top>
          <StatusDisplayContainer sx={{ cursor: 'pointer' }} onClick={handleOpenCandidateModal}>
            <HiringRequestStatusDisplay
              status={status}
              hiringRequestId={hiringRequestId}
              actionsComplete={hasCompletedAllRequiredActions}
            />
          </StatusDisplayContainer>
        </Top>
        <RowCandidateAndRequestorInfo
          candidate={candidate}
          created={created}
          requestor={requestor}
          onClick={handleOpenCandidateModal}
        />
        <RowJobInfo role={role} notesCount={notesCount} onClick={handleOpenCandidateModal} />
        <CandidateRowActions
          applicationId={applicationId}
          actions={actions}
          onOpenModal={onOpenModal}
          candidateId={candidate.id}
          hasCompletedAllRequiredActions={hasCompletedAllRequiredActions}
          requirements={requirements}
          roleId={role.id}
        />
      </CandidateRow>
      {isModalOpen &&
        (currentModalOpen.modalType === CandidateFeedbackModalTypes.REFERENCE ||
          currentModalOpen.modalType === CandidateFeedbackModalTypes.SCORECARD) && (
          <CandidateFeedbackModal
            hiringRequestId={hiringRequestId}
            open={Boolean(currentModalOpen)}
            onClose={onCloseModal}
            roleTitle={role.title}
            currentModalOpen={currentModalOpen}
            roleId={role.id}
            candidate={{
              first_name: candidate.first_name,
              last_name: candidate.last_name,
              id: candidate.id,
            }}
          />
        )}
      {isModalOpen && currentModalOpen.modalType === CandidateFeedbackModalTypes.CANDIDATE && (
        <CandidateModal
          open={isModalOpen}
          onClose={onCloseModal}
          currentRow={currentRow}
          key={currentRow.candidate.id}
        />
      )}
    </>
  );
};

const StatusDisplayContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(3),
}));

const Top = styled(Box)(() => ({
  display: 'flex',
}));
